import { TextTransform } from '../../ui/toolkit/texttransform/texttransform';
import { ToneStatus } from '../../ui/toolkit/toneoptions/tone/tonestatus';
import { ToneRowOptionsPrivilage, ToneRowOptionsPrivilageFromJsonImpl } from '../../ui/toolkit/toneoptions/tone/tonerowcomponent';

export interface ToneDto
{
    getId(): string;
    getToneName(): string;
    getArtistName(): string;
    getImgPath(): string;
    getToneUrl(): string;
    getAlbumName() : string;
    getDownloadCount() : string;
    getLikeCount() : string;
    getPrice() : string;
    getCategoryId() : number;
    getExpirydate() : string;
    getBaseCategoryId() : number;
    getContentId(): string;
    getStatus(): ToneStatus;
    getContentName(): string;
    getTonePrivilage(): ToneRowOptionsPrivilage;

    setId(id:string) : void;
    setStatus(status: ToneStatus): void;
    setToneName(toneName:string) : void;
    setToneUrl(toneUrl:string) : void;
    setAlbumName(albumName:string) : void;
    setArtistName(artistName:string) : void;
    setImgPath(imgPath:string) : void;
    setLikeCount(likeCount:string) : void;
    setPrice(price:string) : void;
    setTonePrivilage(tonePrivilage: ToneRowOptionsPrivilage): void;
}

export class ToneDtoImpl implements ToneDto
{
    private id: string;
    private toneName: string;
    private imgPath: string;
    private artistName: string;
    private toneURL: string;
    private albumName: string;
    private downloadCount: string;
    private likeCount: string;
    private price: string;
    private categoryId: number;
    private expiryDate: string;
    private baseCategoryId: number;
    private contentId: string;
    private contentName: string;
    private tonePrivilage: ToneRowOptionsPrivilageFromJsonImpl;
    private status: ToneStatus ;
    
    setId(id: string)
    {
        this.id = id;
    }

    setToneUrl(toneUrl: string)
    {
        this.toneURL = toneUrl;
    }
    
    setToneName(toneName: string)
    {
        this.toneName = TextTransform.convertToCaptialize(toneName);
    }

    setImgPath(imgPath: string)
    {
        this.imgPath = imgPath;
    }

    getToneName(): string 
    {
        return this.toneName;
    }    

    getToneUrl(): string {
        return this.toneURL;
    }

    getImgPath(): string 
    {
        return this.imgPath;
    }

    getId(): string 
    {
       return this.id;
    }

    getAlbumName(): string
    {
        return this.albumName;
    }
    setAlbumName(albumName: string)
    {
        this.albumName = TextTransform.convertToCaptialize(albumName);
    }

    getArtistName(): string
    {
        return this.artistName;
    }
    setArtistName(artistName: string)
    {
        this.artistName = TextTransform.convertToCaptialize(artistName);
    }

    setStatus(status: ToneStatus)
    {
        this.status = status;
    }
    getStatus(): ToneStatus
    {
        return this.status;
    }

    getDownloadCount(): string
    {
        return this.downloadCount;
    }
    setDownloadCount(downloadCount: string)
    {
        this.downloadCount = downloadCount;
    }

    getLikeCount(): string
    {
        return this.likeCount;
    }
    setLikeCount(likeCount: string)
    {
        this.likeCount = likeCount;
    }

    getPrice(): string
    {
        return this.price;
    }
    setPrice(price: string)
    {
        this.price = price;
    }

    getCategoryId(): number
    {
        return this.categoryId;
    }
    setCategoryId(categoryId: number)
    {
        this.categoryId = categoryId;
    }

    getExpirydate(): string
    {
        return this.expiryDate;
    }
    setExpirydate(expiryDate: string)
    {
        this.expiryDate = expiryDate;
    }

    getBaseCategoryId(): number
    {
        return this.baseCategoryId;
    }
    setBaseCategoryId(baseCategoryId: number)
    {
        this.baseCategoryId = baseCategoryId;
    }

    getContentId(): string
    {
        return this.contentId;
    }
    setContentId(contentId: string)
    {
        this.contentId = contentId;
    }

    getContentName(): string
    {
        return this.contentName;
    }
    setContentName(contentName: string)
    {
        this.contentName = TextTransform.convertToCaptialize(contentName);
    }

    getTonePrivilage(): ToneRowOptionsPrivilageFromJsonImpl {
       return this.tonePrivilage;
    }
    setTonePrivilage(tonePrivilage: ToneRowOptionsPrivilageFromJsonImpl): void {
       this.tonePrivilage = tonePrivilage;
    }

    fromJson(toneData: any)
    {
        this.setId(toneData.id);
        this.setToneName(toneData.toneName);
        this.setToneUrl(toneData.toneURL);
        this.setAlbumName(toneData.albumName);
        this.setStatus(toneData.status);
        this.setArtistName(toneData.artistName);
        this.setExpirydate(toneData.expiryDate);
        this.setImgPath(toneData.imgPath);
        this.setLikeCount(toneData.likeCount);
        this.setPrice(toneData.price);

        console.log("------toneData.tonePrivilage: " + toneData.tonePrivilage);
        this.setTonePrivilage(toneData.tonePrivilage);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/tonedto.ts